/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { BaseForm } from './base-form';
import { ControlValueAccessor } from '@angular/forms';
import { Directive } from "@angular/core";

@Directive()
export abstract class BaseCVAForm<T> extends BaseForm<T> implements ControlValueAccessor {

  protected onChange: any | undefined = undefined;
  protected onTouched: any | undefined = undefined;
  protected disabled: boolean | undefined = undefined;

  protected constructor() {
    super();
  }

  writeValue(value: T): void {
    if (value) {
      this.model = value;
      this.updateFormValue();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.form?.valueChanges.subscribe(this.onChange);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected updateFormValue(
    newValue: T = this.model,
    options: { onlySelf?: boolean; emitEvent?: boolean } = {emitEvent: false}
  ) {
    super.updateFormValue(newValue, options);
  }
}
